import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ComboboxItem, Modal, ScrollAreaAutosize, Text } from "@mantine/core";
import { IconMicroscope } from "@tabler/icons-react";

import { MAX_FILENAME_LENGTH_AFTER_UPLOAD } from "@constants/index";

import { useAuth } from "@contexts/auth";

import { Appointment, LabAppointmentDetail } from "@customTypes/appointment";

import {
  StyledAnalysisTestsModalContent,
  StyledLabCard,
} from "./AnalysisTestsModal.styled";


interface ModalProps {
  opened: boolean;
  close: () => void;
  selectedRow: Appointment;
}

const MAX_FILENAME_LENGTH = MAX_FILENAME_LENGTH_AFTER_UPLOAD + 5;

export const AnalysisTestsModal = ({
  opened,
  close,
  selectedRow,
}: ModalProps) => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [labTests, setLabTests] = useState<ComboboxItem[]>([]);

  useEffect(() => {
    if (selectedRow) {
      setLabTests(
        ((selectedRow.details as LabAppointmentDetail).serviceTypeIds as ComboboxItem[]) || []
      );
    }
  }, [selectedRow]);

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size={"lg"}
      title={<Text fw={500}>{t("analysis-tests")}</Text>}
      scrollAreaComponent={ScrollAreaAutosize}>
      <StyledAnalysisTestsModalContent>
        <Text fz={15} fw={600}>
          {t("ordered-analysis")}
        </Text>

        <div className="grid">
          {labTests?.map((test, index) => (
            <LabCard key={index}>{test.label}</LabCard>
          ))}
        </div>
      </StyledAnalysisTestsModalContent>
    </Modal>
  );
};

interface LabCardProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
}
const LabCard = ({ children, icon }: LabCardProps) => {
  return (
    <StyledLabCard>
      <div className="icon-wrapper">
        {icon ?? <IconMicroscope size={23} stroke={1.5} />}
      </div>
      <Text fz={14} lh={1.4}>
        {children}
      </Text>
    </StyledLabCard>
  );
};
